import React, { memo } from 'react';
import PropTypes from 'prop-types';

import Traductor from '../../Traductor';

const TrolleyHeader = ({ amount, expanded, onClose }) => {
    const t = new Traductor();
    return (
        <li className="c-page-head-nav__dropdown-list-item">
            <a
                className="u-float-right c-header-profile-dropdown__link js-dropdown__button"
                href="#"
                onClick={onClose}
            >
                <i
                    className="c-icon  c-icon--[semantic-crossed-out] c-icon--xsmall"
                    aria-hidden={!expanded}
                />
            </a>
            <p className="u-h3 u-mt u-mb-none">
                <span className="u-text-capitalize">
                    {t.getTraduction('Vehículos')}
                </span>{' '}
                <span className="u-text-lowercase">
                    {t.getTraduction('SelectedPlural')}
                </span>{' '}
                ({amount})
            </p>
        </li>
    );
};

TrolleyHeader.propTypes = {
    amount: PropTypes.number.isRequired,
    expanded: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default memo(TrolleyHeader);
